import type { ReactNode } from 'react';

import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';
import { mediaMinWidth } from '@prose-ui/utils/media';

const GridLayout = styled.div`
  display: block;
  width: 100%;
  background-color: ${theme.colors.neutral['200']};
  ${mediaMinWidth('md')} {
    display: grid;
    grid-template:
      'beforeFocus focus' auto
      'afterFocus focus' 1fr / 0.56fr 0.44fr;
    min-height: calc(100vh - ${theme.env.headerHeight});
  }
`;

const Focus = styled.div`
  grid-area: focus;
  display: flex;
  flex-direction: column;
  margin: 0 ${theme.spacing['6x']};
  background-color: ${theme.colors.neutral['100']};
  ${mediaMinWidth('md')} {
    margin: 0;
    padding: 0;
  }
`;

const BeforeFocusWrapper = styled.div`
  grid-area: beforeFocus;
`;
const AfterFocusWrapper = styled.div`
  grid-area: afterFocus;
`;

type Props = {
  slots: {
    beforeFocus: ReactNode;
    focus: ReactNode;
    afterFocus: ReactNode;
  };
};

export const FocusedAsideSection = ({ slots: { beforeFocus, focus, afterFocus } }: Props) => {
  return (
    <GridLayout>
      <BeforeFocusWrapper>{beforeFocus}</BeforeFocusWrapper>
      <Focus>{focus}</Focus>
      <AfterFocusWrapper>{afterFocus}</AfterFocusWrapper>
    </GridLayout>
  );
};
